module.exports = __webpack_public_path__ + "cf5f9efd18a53ae6fe2d03aa1020f65b.svg";